import CityPageTemplate from "../city-template/CityPageTemplate";
import { chesterVaConfig } from "./data";

export default function ChesterVaPage() {
  return <CityPageTemplate config={chesterVaConfig} />;
}